import { useState, useEffect } from "react"
import { storage } from "../firebase"

const storageRef = storage.ref()

const fileDirs = [
  "screenshotLegalInsurance",
  "signature",
  "documents",
  "forms",
  "poa",
  "fee-agreement",
]


export default function useFiles (
  { userId, gdprCaseId }: {
    userId: string
    gdprCaseId: string
  },
): [Record<string, any[]>, boolean] {
  const initialDirToList =  Object.fromEntries(
    fileDirs.map(fileName => [fileName, []]),
  )
  const [fileObject, setFileObject] = useState(initialDirToList)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!userId) {
      console.error("User not found")
      setLoading(false)
      return
    }
    if (!gdprCaseId) {
      console.error("Gdpr case not found")
      setLoading(false)
      return
    }

    async function mapLinks (documentsRef: { items: any[]}): Promise<any> {
      return Promise.all(documentsRef.items.map(async (item) => {
        const downloadURL = await item.getDownloadURL()
        const metadata = await item.getMetadata()
        return {
          ...item,
          meta: { ...metadata },
          name: item.name,
          downloadURL,
        }
      }))
    }

    async function getUserFiles () {
      setLoading(true)
      const filesRef = storageRef
        .child(userId)
        .child("gdprCases")
        .child(gdprCaseId)

      const dirToEntriesObj = Object.fromEntries(
        await Promise.all(
          fileDirs.map(async fileName => {
            const ref = filesRef.child(fileName)
            const allFiles = await ref.listAll()
            const links = await mapLinks(allFiles)
            return [fileName, links || []]
          }),
        ),
      )

      setFileObject(dirToEntriesObj)

      setLoading(false)
    }

    getUserFiles()
      .catch(console.error)

  }, [userId, gdprCaseId])

  return [fileObject, loading]
}
